module.exports = __webpack_public_path__ + "img/result-detail-communication-outright03.84d8286c.svg";